module.exports = __webpack_public_path__ + "static/media/telemedicine.008928cc.jpg";